export default {
  'app.true': '是',
  'app.false': '否',
  'app.403.page': '无此页面访问权限',
  'app.403.page.tip': '如需获取访问权限，请联系管理员',
};
